<template lang="pug">
div
  form.form-horizontal
    .form-group(v-for='(item, index) in items')
      label.col-md-12 {{item.label}}
      .col-md-12
        input.form-control(type='text', v-model="formData[item.name]" ,:name='item.name', value='', placeholder='')
  button.btn.btn-success.waves-effect.waves-light.m-r-10(v-on:click="register") 登録
</template>

<script>
import axios from 'axios'
export default {
  name: 'Top',
  data () {
    return {
      items: [
        {
          name: 'work_id',
          label: 'No'
        },
        {
          name: 'material',
          label: '説明文'
        }
      ],
      formData: {
        'show_work_category': '',
        'work_id': '',
        'material': ''
      }
    }
  },
  methods: {
    register: function () {
      let inputData = JSON.stringify(this.formData)
      console.log(inputData)
      axios({
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/tech-info',
        method: 'POST',
        data: {
          data: inputData
        }
      })
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/work/PickupEdit.vue